"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var common_hooks_1 = require("@l2p/common-hooks");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var Timer = function (_a) {
    var endDate = _a.endDate;
    var time = (0, common_hooks_1.useTimer)({ endDate: endDate }).time;
    var tDef = (0, next_intl_1.useTranslations)();
    if (!endDate)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.num }, "".concat((time === null || time === void 0 ? void 0 : time.days) || 0).concat(tDef('timer.days'))),
        react_1.default.createElement("div", null, ":"),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.num }, "".concat((time === null || time === void 0 ? void 0 : time.hours) || 0).concat(tDef('timer.hours'))),
        react_1.default.createElement("div", null, ":"),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.num }, "".concat((time === null || time === void 0 ? void 0 : time.minutes) || 0).concat(tDef('timer.minutes'))),
        react_1.default.createElement("div", null, ":"),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.num }, "".concat((time === null || time === void 0 ? void 0 : time.seconds) || 0).concat(tDef('timer.seconds')))));
};
exports.default = Timer;
